export const SESSION_SAVE_CACHE_KEY = 'px_session_save_v1';
export const SESSION_NEEDS_SAVE_KEY = 'px_session_needs_save_v1';
export const SESSION_SAVE_SKIP_MS = 45 * 60 * 1000;

export const markNeedsSaveAfterLogin = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(SESSION_NEEDS_SAVE_KEY, '1');
  } catch {
    // ignore
  }
};

export const clearNeedsSaveAfterLogin = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    sessionStorage.removeItem(SESSION_NEEDS_SAVE_KEY);
  } catch {
    // ignore
  }
};

export const needsSaveAfterLogin = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    return sessionStorage.getItem(SESSION_NEEDS_SAVE_KEY) === '1';
  } catch {
    return false;
  }
};

export const shouldSkipSessionSave = (email, ip) => {
  if (needsSaveAfterLogin()) {
    return false;
  }
  if (!email || !ip || typeof window === 'undefined') {
    return false;
  }
  try {
    const raw = sessionStorage.getItem(SESSION_SAVE_CACHE_KEY);
    if (!raw) {
      return false;
    }
    const { email: cachedEmail, ip: cachedIp, savedAt } = JSON.parse(raw);
    if (cachedEmail !== email || cachedIp !== ip) {
      return false;
    }
    return Date.now() - savedAt < SESSION_SAVE_SKIP_MS;
  } catch {
    return false;
  }
};

export const clearSessionSaveCache = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    sessionStorage.removeItem(SESSION_SAVE_CACHE_KEY);
    return true;
  } catch {
    return false;
  }
};

export const markSessionSaved = (email, ip) => {
  if (!email || !ip || typeof window === 'undefined') {
    return;
  }
  try {
    clearNeedsSaveAfterLogin();
    sessionStorage.setItem(
      SESSION_SAVE_CACHE_KEY,
      JSON.stringify({ email, ip, savedAt: Date.now() })
    );
  } catch {
    // ignore storage errors
  }
};
